"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCorporateCreditPolicySchema = exports.createCorporateCreditPolicySchema = exports.corporateCreditPolicyShape = exports.corporatePaymentCycleEnum = void 0;
const zod_1 = require("zod");
exports.corporatePaymentCycleEnum = zod_1.z.enum(['MONTHLY', 'FORTNIGHTLY', 'QUARTERLY', 'CUSTOM']);
exports.corporateCreditPolicyShape = {
    corporateId: zod_1.z.string().uuid(),
    creditLimit: zod_1.z.number().nonnegative().nullable().optional(),
    creditDays: zod_1.z.number().int().nonnegative().nullable().optional(),
    paymentCycle: exports.corporatePaymentCycleEnum.optional(),
    allowOpCredit: zod_1.z.boolean().optional(),
    allowIpCredit: zod_1.z.boolean().optional(),
    allowPharmacyCredit: zod_1.z.boolean().optional(),
    allowLabCredit: zod_1.z.boolean().optional(),
    allowRadiologyCredit: zod_1.z.boolean().optional(),
    allowProcedureCredit: zod_1.z.boolean().optional(),
    allowPackageCredit: zod_1.z.boolean().optional(),
    allowEmergencyCredit: zod_1.z.boolean().optional(),
    allowPartialPayment: zod_1.z.boolean().optional(),
    requiresPreAuthorization: zod_1.z.boolean().optional(),
    approvalRequired: zod_1.z.boolean().optional(),
    approvalAuthorityUserId: zod_1.z.string().uuid().nullable().optional(),
    defaultPriceListId: zod_1.z.string().uuid().nullable().optional(),
    defaultDiscountPercent: zod_1.z.number().min(0).max(100).nullable().optional(),
    isActive: zod_1.z.boolean().optional(),
};
exports.createCorporateCreditPolicySchema = zod_1.z.object(exports.corporateCreditPolicyShape);
exports.updateCorporateCreditPolicySchema = exports.createCorporateCreditPolicySchema.partial();
//# sourceMappingURL=corporate-credit-policy.schema.js.map